import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getCertificateRegistrationNumber = (fiscalType: string) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP
        ? 'Series and number of Certificate*'
        : ft === FiscalType.JSC
        ? 'Scan certificate. state JSC registration*'
        : ft === FiscalType.PJSC
        ? 'Scan certificate. state PJSC registration*'
        : ft === FiscalType.CJSC
        ? 'Scan certificate. state CJSC registration*'
        : ft === FiscalType.OsOO
        ? 'Registration number*'
        : 'Registration number*',
      rus: ft === FiscalType.IP
        ? 'Серия и номер Свидетельства*'
        : ft === FiscalType.JSC
        ? 'Cвид. гос. регистрации АО (cерия и номер)*'
        : ft === FiscalType.PJSC
        ? 'Cвид. гос. регистрации ПАО (cерия и номер)*'
        : ft === FiscalType.CJSC
        ? 'Cвид. гос. регистрации ЗАО (cерия и номер)*'
        : ft === FiscalType.OsOO
        ? 'Регистрационный номер*'
        : 'Регистрационный номер*',
      kz: ft === FiscalType.IP
        ? 'Куәліктің сериясы мен нөмірі*'
        : ft === FiscalType.JSC
        ? 'Сканерлеу сертификаты. күй АҚ тіркеу*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Сканерлеу сертификаты. күй ЖАҚ тіркеу*'
        : ft === FiscalType.OsOO
        ? 'Тіркеу нөмірі*'
        : 'Тіркеу нөмірі*',
    },
    placeholder: {
      eng: 'xxxx xxxxxxx',
      rus: 'xxxx xxxxxxx',
      kz: 'xxxx xxxxxxx',
    },
    invalidText: {
      eng: 'Enter the series and number correctly',
      rus: 'Введите серию и номер корректно ',
      kz: 'Серия мен нөмірді дұрыс енгізіңіз',
    },
  }
}

export const getCertificateRegistrationNumberRf = (fiscalType: string) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP
        ? 'Certificate of registration of an IE'
        : ft === FiscalType.JSC
        ? 'Scan certificate. state JSC registration'
        : ft === FiscalType.PJSC
        ? 'Scan certificate. state PJSC registration'
        : ft === FiscalType.CJSC
        ? 'Scan certificate. state CJSC registration'
        : ft === FiscalType.OsOO
        ? 'Registration number'
        : 'Registration number',
      rus: ft === FiscalType.IP
        ? 'Свидетельство о регистрации ИП'
        : ft === FiscalType.JSC
        ? 'Cвид. гос. регистрации АО (cерия и номер)'
        : ft === FiscalType.PJSC
        ? 'Cвид. гос. регистрации ПАО (cерия и номер)'
        : ft === FiscalType.CJSC
        ? 'Cвид. гос. регистрации ЗАО (cерия и номер)'
        : ft === FiscalType.OsOO
        ? 'Регистрационный номер'
        : 'Регистрационный номер',
      kz: ft === FiscalType.IP
        ? 'ЖК тіркеу туралы куәлік'
        : ft === FiscalType.JSC
        ? 'Сканерлеу сертификаты. күй АҚ тіркеу'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Сканерлеу сертификаты. күй ЖАҚ тіркеу'
        : ft === FiscalType.OsOO
        ? 'Тіркеу нөмірі'
        : 'Тіркеу нөмірі',
    },
    placeholder: {
      eng: 'xx xxxxxxxxx',
      rus: 'xx xxxxxxxxx',
      kz: 'xx xxxxxxxxx',
    },
    invalidText: {
      eng: 'Enter the series and number correctly',
      rus: 'Введите серию и номер корректно ',
      kz: 'Серия мен нөмірді дұрыс енгізіңіз',
    },
  }
}
